import React from 'react';
import { connect } from 'react-redux';

import { DatePicker } from 'redpoints-front-components/index';
import { getDefaultDateRanges } from 'redpoints-front-common/helpers';

import { allIncidentsFiltersSetClosureDate } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersClosureDate } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersClosureDate = ({
  allIncidentsFiltersSetClosureDate,
  closureDate,
}) => {
  const handlerSetClosureDate = closureDate =>
    allIncidentsFiltersSetClosureDate({ closureDate });

  return (
    <DatePicker
      label={translate('reporting.allIncidentsInternal.filters.closureDate')}
      rangePicker
      ranges={getDefaultDateRanges()}
      onChange={handlerSetClosureDate}
      value={closureDate || undefined}
    />
  );
};

const mapStateToProps = state => {
  return {
    closureDate: getAllIncidentsFiltersClosureDate(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetClosureDate,
})(AllIncidentsFiltersClosureDate);
